// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_nl-0";
export var discountCodeInput = "_nl-1";